const loadEnv = {
  CLARITY_PROJECT_ID: import.meta.env.CHAT_CLARITY_PROJECT_ID,
  // new env for sentry
  ENVIRONMENT: import.meta.env.CHAT_ENVIRONMENT,
  SENTRY_DSN: import.meta.env.CHAT_SENTRY_DSN,
};

export const env = loadEnv;

export default loadEnv;
